import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { redirectIfAuthenticatedGuard, sessionGuard } from '@the-hive-frontend/auth-session';

import { DemoModeService } from './demo-mode.service';

export const demoOrSessionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): MaybeAsync<GuardResult> => {
  if (inject(DemoModeService).active()) {
    return true;
  }
  return sessionGuard(route, state);
};

export const demoOrRedirectIfAuthenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): MaybeAsync<GuardResult> => {
  if (inject(DemoModeService).active()) {
    return inject(Router).parseUrl('/actions');
  }
  return redirectIfAuthenticatedGuard(route, state);
};
